import { useReducer, useEffect, useState } from 'react';
import conso from '%/conso';
import ax, { GET_CATEGORIES, PRODUCTS_BY_CATEGORY, QUERY_PRODUCTS } from '%/axios';

const init = {
  products: {
    list: (PRODUCT_RESULTS)?.data || [],
    current_page: 1,
    last_page: (PRODUCT_RESULTS)?.last_page || 1,
    total: (PRODUCT_RESULTS)?.total
  },
  categories: {
    list: []
  },
  secondary_products: {
    list: [],
    current_page: 1,
    last_page: 1,
    total: 0
  }
}

// example improvement on filter query results
// store the list the associates with each filter option
// {
//   "Beacon Color:Amber": [{}, {}, {}],
//   "Beacon Color:Blue": [{},{},{}]
// }

const catProdReducer = (state, action) => {
  switch (action.type) {

    case 'GET_CATEGORIES':
      return {
        ...state,
        categories: {
          ...state.categories,
          list: action.list
        }
      }
    case 'INIT_PRODUCTS':
      return {
        ...state,
        products: {
          ...state.products,
          list: action.list,
          last_page: action.last_page,
          total: action.total
        }
      }

    case 'SECONDARY_PRODUCTS':
      return {
        ...state,
        secondary_products: {
          ...state.secondary,
          list: action.list,
          last_page: action.last_page,
          total: action.total
        }
      } 

    case 'SEARCH_PRODUCTS':
      const { body } = action
      return {
        ...state,
        products: {
          list: body.items,
          total: body.total,
          last_page: body.numPages,
          current_page: body.current_page || 1,
        },
      }

    case 'HANDLE_PAGINATION':
      const { list, current_page, total, last_page } = action;
      return {
        ...state,
        products: {
          ...state.products,
          list,
          current_page,
          total: total || state.total,
          last_page: last_page || state.last_page
        }
      }

    case 'INITIALIZE':
      return init;
    default:
      return state;
  }
}
const useCategoryProduct = () => {


  const [catProd, dispatch] = useReducer(catProdReducer, init);

  const [catProdLoading, setCatProdLoading] = useState(false);

  const getCategories = async (parent_id = null, name) => {
    try {
      const res = await ax(GET_CATEGORIES, { parent_id, name });
      dispatch({ type: 'GET_CATEGORIES', list: res })
    } catch (er) {
      conso.trace(er);
    }
  }

  const initializeResults = () => {
    dispatch({ type: 'INITIALIZE' });
  }

  const getSecondaryProducts = async (categoryId, categoryName) => {
    try {
      const res = await ax(QUERY_PRODUCTS, {
        qs: categoryName,
        filters: [],
        page: 1,
        sort: {},
        category_id: categoryId
      })
      if (res) {
        dispatch({ type: 'SECONDARY_PRODUCTS', list: res.items, last_page: res.last_page, total: res.count })

      }
    } catch (er) {
      conso.trace(er);
    }
  }

  const queryProductsApi = async (qs = document.querySelector('#search_query')?.value, filters = {}, page = 1, sort = {}) => {
    // if (!qs) return;
    setCatProdLoading(true);
    try {
      const res = await ax(QUERY_PRODUCTS, {
        qs,
        filters,
        page,
        sort,
        category_id: CATEGORY_ID
      })
      if (res) {
        dispatch({ type: 'HANDLE_PAGINATION', list: res.items, current_page: page, last_page: res.last_page, total: res.count })

      }
    } catch (er) {
      conso.trace(er);
    }
    setCatProdLoading(false);
  }

  const getProductsByCategory = async (category_name) => {
    try {
      const res = await ax(PRODUCTS_BY_CATEGORY, { category_name })
      if (res) {
        dispatch({
          type: 'INIT_PRODUCTS',
          list: res.items,
          last_page: res.last_page,
          total: res.total
        })
        init.products.list = res.items;
        init.products.last_page = res.last_page;
        init.products.total = res.total;
      }

    } catch (er) {
      conso.trace(er);
    }
  }

  const setProductResultsPagesTotal = (data) => {
    dispatch({
      type: 'SEARCH_PRODUCTS',
      body: data
    })
  }

  useEffect(() => {
    // getCategories();
  }, [])

  return {
    catProd,
    getCategories,
    getProductsByCategory,
    setProductResultsPagesTotal,
    catProdLoading,
    setCatProdLoading,
    queryProductsApi,
    initializeResults,
    getSecondaryProducts
  };

}
export default useCategoryProduct;